import { getXPlatformTokenWithCode } from '@cosign/utils/cookie'
import { getXPlatformTokenDecoded } from '@cosign-services/utils/getXPlatformToken'
import { AnalyticsPlatforms, createAnalyticsProviders } from '@dni-analysis'
import { registerCosignEvents } from '@dni-analysis/events/registerCosignEvents'
import { getCampaignCodeFromPath } from '@utils/getCampaignCodeFromPath'
import Cookies from 'js-cookie'

export const initDniAnalysis = () => {
  const campaignCode = getCampaignCodeFromPath()

  /*
    Fastpass 的 x-platform-token 存在 campaign-specific cookie (e.g. dcspartnertw_x_platform_token)
    Bridge 到全域 x-platform-token 讓 registerCosignEvents 能讀取，直接復用既有其他平台用的機制
  */
  const campaignToken = campaignCode ? getXPlatformTokenWithCode(campaignCode) : undefined
  if (campaignToken) {
    Cookies.set('x-platform-token', campaignToken)
  }

  const xPlatformInfo = getXPlatformTokenDecoded()
  const userId = xPlatformInfo?.platformUid

  createAnalyticsProviders({
    [AnalyticsPlatforms.GA4]: {
      measurementId: import.meta.env.VITE_GA4_TRACKING_ID,
      userId,
    },
    [AnalyticsPlatforms.META_PIXEL]: {
      measurementId: import.meta.env.VITE_META_TRACKING_ID,
      userId,
    },
    [AnalyticsPlatforms.ALETHEIA]: {
      appEnv: import.meta.env.VITE_APP_ENV,
      userId,
      campaignCode,
    },
    [AnalyticsPlatforms.STATSIG]: {
      sdkKey: import.meta.env.VITE_STATSIG_SDK_KEY,
      user: {
        userID: userId,
      },
      appEnv: import.meta.env.VITE_APP_ENV,
    },
  })

  registerCosignEvents()
}
